
















import { Component, Prop } from "vue-property-decorator";
import axios from "axios";
import { State, Action, Getter } from "vuex-class";
import EventBus from "../Plugins/eventbus";
import ParticaBaseView from "../Views/Base/ParticaBaseView.vue";
import LoginForm from "@/Ui-Components/Account/LoginForm.vue";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import { UserModel, AccountClient } from "../Generated/ParticaAPI";
import { AccountToken } from "./customauthservice";
import { eParticaAction, getActionName, ParticaEvent } from "../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../Models/Buttons";

const namespace: string = "config";

@Component({
	name: "AuthLogin",
	components: { LoginForm, ParticaError, ParticaRowContainer, ParticaCard }
})
export default class AuthLogin extends ParticaBaseView {
	@Prop() private from: any;
	private authWindow: Window | null = null;
	private data: UserModel = new UserModel();
	private accountService: AccountClient;
	private loginService: AccountToken;

	private buttons: ButtonConfig[] = [
		{ label: "Login", action: eParticaAction.ACCOUNT_LOGIN, type: ButtonType.OK } as ButtonConfig,
		{ label: "Register", action: eParticaAction.ACCOUNT_REGISTER, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Forgotten Password?", action: eParticaAction.ACCOUNT_FORGOTTEN_PASSWORD, type: ButtonType.Normal } as ButtonConfig,
		{ label: "Resend Welcome Email", action: eParticaAction.ACCOUNT_RESEND_WELCOME, type: ButtonType.Normal } as ButtonConfig,
	];

	private async mounted() {
		this.accountService = new AccountClient();
		this.loginService = new AccountToken();
		// only add message listener once.
		if ((window as any).added !== true) {
			(window as any).added = true;
			if (window.addEventListener) {
				window.addEventListener("message", this.handleMessage.bind(this), false);
			} else {
				(window as any).attachEvent("onmessage", this.handleMessage.bind(this));
			}
		}
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			switch (event.action) {
				case eParticaAction.ACCOUNT_LOGIN: {
					const authData = await this.loginService.getToken(this.data.email, this.data.password);
					this.loggedIn(authData);
					break;
				}
				case eParticaAction.ACCOUNT_FORGOTTEN_PASSWORD: {
					this.navigate("/forgottenpassword", undefined);
					break;
				}
				case eParticaAction.ACCOUNT_RESEND_WELCOME: {
					this.navigate("/resendwelcome", undefined);
					break;
				}
				case eParticaAction.ACCOUNT_REGISTER: {
					this.navigate("/signup", undefined);
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		}
	}

	private async handleMessage(event: Event) {
		const message = event as MessageEvent;
		// Only trust messages from the below origin.
		if (message.origin !== location.origin) {
			return;
		}
		if (!message.data) {
			return;
		}
		if (message.data.source === "vue-devtools-backend") {
			return;
		}

		if (message.data) {
			if (typeof message.data === "string" && message.data.startsWith("{")) {
				// lots of webpack messages to window so remove some.
				const result = JSON.parse(message.data);
				const externalData: any = {
					provider: result.provider,
					externalAccessToken: result.external_access_token,
					Id: result.external_id,
					userName: result.external_user_name,
					givenname: result.givenname,
					surname: result.surname
				};
				axios.defaults.baseURL = this.stateconfig.apiroot;
				const authData = await this.accountService.obtainLocalAccessToken(
					externalData.provider,
					externalData.externalAccessToken,
					externalData.Id
				);
				this.loggedIn(authData);
				if (this.authWindow) {
					this.authWindow.close();
				}
			}
		}
	}

	// configure site for new user.
	private loggedIn(authData: any) {
		axios.defaults.headers.common.Authorization = "Bearer " + authData.access_token;
		this.settoken("Bearer " + authData.access_token);
		this.setuser(authData.userName);
		this.setaccount(0);
		this.ShowSnackbar("Welcome " + authData.userName);
		this.setadmin(authData.hasAdminView);
		localStorage.user = authData.userName;
		localStorage.auth = authData.access_token;
		localStorage.admin = authData.hasAdminView;
		this.ReloadMenu("");
		if (this.from) {
			this.navigate(this.from, undefined);

		} else {
			this.navigate("home", { id: 0 });
		}
	}


	private login(provider: any) {
		const redirectUri = location.origin + "/authComplete.html";
		const externalProviderUrl =
			this.stateconfig.apiroot +
			"/Account/ExternalLogin?provider=" +
			provider +
			"&response_type=token&client_id=undefined" +
			"&redirect_uri=" +
			redirectUri;
		this.authWindow = window.open(
			externalProviderUrl,
			"Authenticate Account",
			"location=0,status=0,width=600,height=750"
		);
	}
}
